<template>
  <el-button class="share-button notification p-0" type="text">
    <i :class="isFullscreen ? 'el-icon-zoom-out large' : 'el-icon-zoom-in large'" @click="click" />
    <label v-if="isFullscreen" class="label-menu-item">Minimizar</label>
    <label v-else class="label-menu-item">Maximizar</label>
  </el-button>
</template>

<script>
import screenfull from "screenfull";

export default {
  name: "Screenfull",
  data() {
    return {
      isFullscreen: false,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    click() {
      if (!screenfull.enabled) {
        this.$message({
          message: "you browser can not work",
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      if (screenfull.enabled) {
        screenfull.on("change", this.change);
      }
    },
    destroy() {
      if (screenfull.enabled) {
        screenfull.off("change", this.change);
      }
    },
  },
};
</script>

<style scoped>
.large {
  font-size: 200%;
}

i {
  display: block;
}

.label-menu-item {
  font-size: 0.5rem;
}
</style>
